const compatModules = {};
import * as Module1 from "./components/bulk-select-bookmarks-dropdown";
compatModules["./components/bulk-select-bookmarks-dropdown"] = Module1;
import * as Module2 from "./components/categories-admin-dropdown";
compatModules["./components/categories-admin-dropdown"] = Module2;
import * as Module3 from "./components/category-chooser";
compatModules["./components/category-chooser"] = Module3;
import * as Module4 from "./components/category-drop-more-collection";
compatModules["./components/category-drop-more-collection"] = Module4;
import * as Module5 from "./components/category-drop";
compatModules["./components/category-drop"] = Module5;
import * as Module6 from "./components/category-drop/category-drop-header";
compatModules["./components/category-drop/category-drop-header"] = Module6;
import * as Module7 from "./components/category-notifications-button";
compatModules["./components/category-notifications-button"] = Module7;
import * as Module8 from "./components/category-row";
compatModules["./components/category-row"] = Module8;
import * as Module9 from "./components/category-selector";
compatModules["./components/category-selector"] = Module9;
import * as Module10 from "./components/color-palette-picker";
compatModules["./components/color-palette-picker"] = Module10;
import * as Module11 from "./components/color-palette-picker/color-palette-picker-row";
compatModules["./components/color-palette-picker/color-palette-picker-row"] = Module11;
import * as Module12 from "./components/color-palettes";
compatModules["./components/color-palettes"] = Module12;
import * as Module13 from "./components/color-palettes/color-palettes-row";
compatModules["./components/color-palettes/color-palettes-row"] = Module13;
import * as Module14 from "./components/combo-box";
compatModules["./components/combo-box"] = Module14;
import * as Module15 from "./components/combo-box/combo-box-header";
compatModules["./components/combo-box/combo-box-header"] = Module15;
import * as Module16 from "./components/composer-actions";
compatModules["./components/composer-actions"] = Module16;
import * as Module17 from "./components/create-color-row";
compatModules["./components/create-color-row"] = Module17;
import * as Module18 from "./components/dropdown-select-box";
compatModules["./components/dropdown-select-box"] = Module18;
import * as Module19 from "./components/dropdown-select-box/dropdown-select-box-header";
compatModules["./components/dropdown-select-box/dropdown-select-box-header"] = Module19;
import * as Module20 from "./components/dropdown-select-box/dropdown-select-box-row";
compatModules["./components/dropdown-select-box/dropdown-select-box-row"] = Module20;
import * as Module21 from "./components/email-group-user-chooser-filter";
compatModules["./components/email-group-user-chooser-filter"] = Module21;
import * as Module22 from "./components/email-group-user-chooser-row";
compatModules["./components/email-group-user-chooser-row"] = Module22;
import * as Module23 from "./components/email-group-user-chooser";
compatModules["./components/email-group-user-chooser"] = Module23;
import * as Module24 from "./components/filter-for-more";
compatModules["./components/filter-for-more"] = Module24;
import * as Module25 from "./components/flair-chooser";
compatModules["./components/flair-chooser"] = Module25;
import * as Module26 from "./components/flair-row";
compatModules["./components/flair-row"] = Module26;
import * as Module27 from "./components/font-selector";
compatModules["./components/font-selector"] = Module27;
import * as Module28 from "./components/font-selector/font-selector-row";
compatModules["./components/font-selector/font-selector-row"] = Module28;
import * as Module29 from "./components/form-template-chooser";
compatModules["./components/form-template-chooser"] = Module29;
import * as Module30 from "./components/future-date-input-selector";
compatModules["./components/future-date-input-selector"] = Module30;
import * as Module31 from "./components/future-date-input-selector/future-date-input-selector-header";
compatModules["./components/future-date-input-selector/future-date-input-selector-header"] = Module31;
import * as Module32 from "./components/future-date-input-selector/future-date-input-selector-row";
compatModules["./components/future-date-input-selector/future-date-input-selector-row"] = Module32;
import * as Module33 from "./components/group-chooser";
compatModules["./components/group-chooser"] = Module33;
import * as Module34 from "./components/group-dropdown";
compatModules["./components/group-dropdown"] = Module34;
import * as Module35 from "./components/group-notifications-button";
compatModules["./components/group-notifications-button"] = Module35;
import * as Module36 from "./components/homepage-style-selector";
compatModules["./components/homepage-style-selector"] = Module36;
import * as Module37 from "./components/homepage-style-selector/homepage-style-selector-row";
compatModules["./components/homepage-style-selector/homepage-style-selector-row"] = Module37;
import * as Module38 from "./components/icon-picker";
compatModules["./components/icon-picker"] = Module38;
import * as Module39 from "./components/list-setting";
compatModules["./components/list-setting"] = Module39;
import * as Module40 from "./components/mini-tag-chooser";
compatModules["./components/mini-tag-chooser"] = Module40;
import * as Module41 from "./components/mini-tag-chooser/selected-collection";
compatModules["./components/mini-tag-chooser/selected-collection"] = Module41;
import * as Module42 from "./components/multi-select";
compatModules["./components/multi-select"] = Module42;
import * as Module43 from "./components/multi-select/format-selected-content";
compatModules["./components/multi-select/format-selected-content"] = Module43;
import * as Module44 from "./components/multi-select/multi-select-filter";
compatModules["./components/multi-select/multi-select-filter"] = Module44;
import * as Module45 from "./components/multi-select/multi-select-header";
compatModules["./components/multi-select/multi-select-header"] = Module45;
import * as Module46 from "./components/multi-select/selected-category";
compatModules["./components/multi-select/selected-category"] = Module46;
import * as Module47 from "./components/multi-select/selected-color";
compatModules["./components/multi-select/selected-color"] = Module47;
import * as Module48 from "./components/none-category-row";
compatModules["./components/none-category-row"] = Module48;
import * as Module49 from "./components/notifications-button";
compatModules["./components/notifications-button"] = Module49;
import * as Module50 from "./components/notifications-button/notifications-button-row";
compatModules["./components/notifications-button/notifications-button-row"] = Module50;
import * as Module51 from "./components/notifications-filter";
compatModules["./components/notifications-filter"] = Module51;
import * as Module52 from "./components/notifications-filter/notifications-filter-header";
compatModules["./components/notifications-filter/notifications-filter-header"] = Module52;
import * as Module53 from "./components/period-chooser";
compatModules["./components/period-chooser"] = Module53;
import * as Module54 from "./components/period-chooser/period-chooser-header";
compatModules["./components/period-chooser/period-chooser-header"] = Module54;
import * as Module55 from "./components/period-chooser/period-chooser-row";
compatModules["./components/period-chooser/period-chooser-row"] = Module55;
import * as Module56 from "./components/search-advanced-category-chooser";
compatModules["./components/search-advanced-category-chooser"] = Module56;
import * as Module57 from "./components/select-kit";
compatModules["./components/select-kit"] = Module57;
import * as Module58 from "./components/select-kit/errors-collection";
compatModules["./components/select-kit/errors-collection"] = Module58;
import * as Module59 from "./components/select-kit/select-kit-body";
compatModules["./components/select-kit/select-kit-body"] = Module59;
import * as Module60 from "./components/select-kit/select-kit-collection";
compatModules["./components/select-kit/select-kit-collection"] = Module60;
import * as Module61 from "./components/select-kit/select-kit-create-row";
compatModules["./components/select-kit/select-kit-create-row"] = Module61;
import * as Module62 from "./components/select-kit/select-kit-filter";
compatModules["./components/select-kit/select-kit-filter"] = Module62;
import * as Module63 from "./components/select-kit/select-kit-header";
compatModules["./components/select-kit/select-kit-header"] = Module63;
import * as Module64 from "./components/select-kit/select-kit-none-row";
compatModules["./components/select-kit/select-kit-none-row"] = Module64;
import * as Module65 from "./components/select-kit/select-kit-row";
compatModules["./components/select-kit/select-kit-row"] = Module65;
import * as Module66 from "./components/select-kit/single-select-header";
compatModules["./components/select-kit/single-select-header"] = Module66;
import * as Module67 from "./components/selected-choice-category";
compatModules["./components/selected-choice-category"] = Module67;
import * as Module68 from "./components/selected-choice-color";
compatModules["./components/selected-choice-color"] = Module68;
import * as Module69 from "./components/selected-choice";
compatModules["./components/selected-choice"] = Module69;
import * as Module70 from "./components/selected-color";
compatModules["./components/selected-color"] = Module70;
import * as Module71 from "./components/selected-flair";
compatModules["./components/selected-flair"] = Module71;
import * as Module72 from "./components/selected-font";
compatModules["./components/selected-font"] = Module72;
import * as Module73 from "./components/selected-name";
compatModules["./components/selected-name"] = Module73;
import * as Module74 from "./components/single-select";
compatModules["./components/single-select"] = Module74;
import * as Module75 from "./components/tag-category-admin-dropdown";
compatModules["./components/tag-category-admin-dropdown"] = Module75;
import * as Module76 from "./components/tag-chooser-row";
compatModules["./components/tag-chooser-row"] = Module76;
import * as Module77 from "./components/tag-chooser";
compatModules["./components/tag-chooser"] = Module77;
import * as Module78 from "./components/tag-drop";
compatModules["./components/tag-drop"] = Module78;
import * as Module79 from "./components/tag-drop/tag-drop-header";
compatModules["./components/tag-drop/tag-drop-header"] = Module79;
import * as Module80 from "./components/tag-dropdown";
compatModules["./components/tag-dropdown"] = Module80;
import * as Module81 from "./components/tag-group-chooser";
compatModules["./components/tag-group-chooser"] = Module81;
import * as Module82 from "./components/tag-notifications-button";
compatModules["./components/tag-notifications-button"] = Module82;
import * as Module83 from "./components/tag-row";
compatModules["./components/tag-row"] = Module83;
import * as Module84 from "./components/tags-intersection-chooser";
compatModules["./components/tags-intersection-chooser"] = Module84;
import * as Module85 from "./components/timezone-input";
compatModules["./components/timezone-input"] = Module85;
import * as Module86 from "./components/topic-chooser";
compatModules["./components/topic-chooser"] = Module86;
import * as Module87 from "./components/topic-notifications-button";
compatModules["./components/topic-notifications-button"] = Module87;
import * as Module88 from "./components/topic-notifications-options";
compatModules["./components/topic-notifications-options"] = Module88;
import * as Module89 from "./components/topic-row";
compatModules["./components/topic-row"] = Module89;
import * as Module90 from "./components/user-chooser";
compatModules["./components/user-chooser"] = Module90;
import * as Module91 from "./components/user-chooser/user-row";
compatModules["./components/user-chooser/user-row"] = Module91;
import * as Module92 from "./components/user-notifications-dropdown";
compatModules["./components/user-notifications-dropdown"] = Module92;
import * as Module93 from "./components/watched-words";
compatModules["./components/watched-words"] = Module93;
import * as Module94 from "./lib/input-utils";
compatModules["./lib/input-utils"] = Module94;
import * as Module95 from "./lib/plugin-api";
compatModules["./lib/plugin-api"] = Module95;
import * as Module96 from "./lib/select-kit-prop-utils";
compatModules["./lib/select-kit-prop-utils"] = Module96;
import * as Module97 from "./services/tag-utils";
compatModules["./services/tag-utils"] = Module97;
export default compatModules;